import { combineReducers } from 'redux'

import authenticationReducer from './authentication.reducer'
import webReducer from './web.reducer'
import shipmentReducer from './shipment.reducer'
import userReducer from './user.reducer'
import clientReducer from './client.reducer'
import amountReducer from './amount.reducer'
import metricsReducer from './metrics.reducer'
import vehiclesReducer from './vehicles.reducer'
import volquetesReducer from './volquetes.reducer'

const rootReducer = combineReducers({
  authenticationReducer,
  webReducer,
  shipmentReducer,
  userReducer,
  clientReducer,
  amountReducer,
  metricsReducer,
  vehiclesReducer,
  volquetesReducer,
})

export default rootReducer
